<template>
    <span class="p-button-wrapper">
        <b-button
            v-bind="$attrs"
            :class="{ 'px-0 py-0 no-border': noBorder }"
            ref="button"
            @click="$emit('click', $event)"
            :disabled="$attrs.disabled || isBusy"
        >
            <slot></slot>
        </b-button>
        <span v-if="isBusy" class="p-button-busy-overlay">
            <b-spinner small variant="primary"></b-spinner>
        </span>
    </span>
</template>

<script>
export default {
    emits: ['click'],
    props: {
        isBusy: {
            type: Boolean,
            default: false
        },
        finishedMessage: {
            type: String,
            default: ''
        },
        noBorder: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        isBusy: {
            handler: function(newVal) {
                if (!newVal && this.finishedMessage != '') {
                    this.$appSuccess(this.finishedMessage)
                }
            }
        }
    }
};
</script>
<style scoped>
.no-border {
    border: 0px;
}
.p-button-wrapper {
    position: relative;
    display: inline-block;
    vertical-align: middle;
}
.p-button-busy-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    pointer-events: none;
}
</style>
